import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import { toggleDrawer, toggleDrawerContent, logout } from '../actions/ui';
import { codeBenchActions } from '@codametrix/ui-common';
import { jumpContext } from '../actions/contexts.action';
export const reducer = createReducer(InitialState.providerDetails, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState.providerDetails
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.providerDetails
        }));
    builder.addCase(toggleDrawerContent.type, (state, action)=>{
        return {
            ...state,
            isOpen: action.payload
        };
    });
    builder.addCase(toggleDrawer.type, (state, action)=>{
        return {
            ...state,
            isDrawerOpen: action.payload
        };
    });
    builder.addCase(codeBenchActions.navigateProvider.pending, (state, action)=>{
        const providerInfoInput = action.meta.arg;
        return {
            ...state,
            isDrawerOpen: true,
            servicesLoading: true,
            isSingleTenantData: !!providerInfoInput.tenantCode,
            providerInfoInput
        };
    });
    builder.addCase(codeBenchActions.navigateProvider.fulfilled, (state, action)=>{
        return {
            ...state,
            isOpen: true,
            providerInfo: action.payload,
            servicesLoading: false
        };
    });
});
export default reducer;
